import { ShipmentsPrototypeRoutes } from "@faire/prototype-playground/workspace/kvz/shipments-page/ShipmentsPrototypeRoutes";
import { Route, Switch } from "react-router-dom";
import BulkProductEditPage from "@faire/prototype-playground/workspace/kvz/bulk-product-edit";
import MultiLocationInventoryDemoPage from "@faire/prototype-playground/workspace/kvz/multi-location-inventory-demo";
import MultiLocationInventoryInventoryPagePage from "@faire/prototype-playground/workspace/kvz/multi-location-inventory-page";
import MultiLocationInventoryNorthstarPage from "@faire/prototype-playground/workspace/kvz/multi-location-inventory-northstar";
import MultiLocationInventorySpeFbbPage from "@faire/prototype-playground/workspace/kvz/multi-location-inventory-spe-fbb";
import MultiLocationInventoryProductEditorPage from "@faire/prototype-playground/workspace/kvz/multi-location-inventory-product-editor";

export function KellyVonZupRoutes() {
  return (
    <Switch>
      <Route path="/kvz/bulk-product-edit" component={BulkProductEditPage} />
      <Route path="/kvz/multi-location-inventory-demo" component={MultiLocationInventoryDemoPage} />
      <Route path="/kvz/multi-location-inventory-northstar" component={MultiLocationInventoryNorthstarPage} />
      <Route path="/kvz/multi-location-inventory-page" component={MultiLocationInventoryInventoryPagePage} />
      <Route path="/kvz/multi-location-inventory-spe-fbb" component={MultiLocationInventorySpeFbbPage} />
      <Route path="/kvz/multi-location-inventory-product-editor" component={MultiLocationInventoryProductEditorPage} />
      <Route path="/kvz/shipments-page" component={ShipmentsPrototypeRoutes} />
    </Switch>
  );
}

export const slug = "kvz";
